// DEPRECATED: wraps ImageCtaLarge. Use that instead.
import '@ungap/custom-elements';
import Vue from 'vue';
import vueCustomElement from 'vue-custom-element';
import Vuelidate from 'vuelidate';

import EVShowroom from './EVShowroom';

Vue.use(Vuelidate);
Vue.use(vueCustomElement);

// Additional Options: https://github.com/karol-f/vue-custom-element#options
// NOTE: at the moment shadowDOM is disabled in webpack for widgets,
// this is due to pollyfills like shadyDOM not working in IE11

Vue.customElement('ev-showroom-cta', EVShowroom);
